import React from "react";
import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { GFFrame, GFHeader } from "@/components/GFFrame";
import { API } from "@/lib/gfApi";

export default function QRPage() {
  const publicUrl = window.location.origin;
  const qrSrc = `${API}/qr`;

  const copy = () => {
    navigator.clipboard.writeText(publicUrl);
    toast.success("Pautan disalin!");
  };

  return (
    <GFFrame testId="qr-page">
      <div className="flex min-h-screen flex-col px-6 pb-10">
        <GFHeader />
        <div className="flex flex-1 flex-col items-center justify-center text-center">
          <div className="gf-gold-line mb-5" />
          <h2 className="font-heading text-2xl font-bold text-[#0F172A]">
            Kod QR Growth Factor
          </h2>
          <p className="mt-2 max-w-xs text-sm text-slate-500">
            Imbas kod ini untuk membuka Growth Factor terus di pelayar telefon. Sesuai
            untuk poster, slaid, dan perkongsian WhatsApp.
          </p>

          <div className="mt-8 rounded-3xl border border-[#E7E2D6] bg-white p-6 shadow-[0_20px_50px_rgba(15,23,42,0.08)]">
            <img
              src={qrSrc}
              alt="QR Growth Factor"
              data-testid="qr-image"
              className="h-56 w-56"
            />
          </div>

          <div className="mt-6 w-full max-w-xs rounded-2xl bg-slate-50 px-4 py-3 text-sm text-slate-600 break-all">
            {publicUrl}
          </div>

          <div className="mt-4 flex w-full max-w-xs gap-3">
            <button
              onClick={copy}
              data-testid="copy-link-btn"
              className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[#0F172A] py-3 text-sm font-bold text-white"
            >
              <Copy className="h-4 w-4" /> Salin Pautan
            </button>
            <a
              href={publicUrl}
              className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[#E7E2D6] py-3 text-sm font-bold text-[#0F172A]"
            >
              <ExternalLink className="h-4 w-4" /> Buka
            </a>
          </div>
        </div>
      </div>
    </GFFrame>
  );
}
